// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vendor-assess-item-sub-total-tr td {\n  color: white !important;\n  background-color: #42a5f5 !important;\n  font-size: 0.95rem;\n  font-weight: 600;\n}\n.vendor-assess-item-sub-total-tr .text-align-right {\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
